import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut, User, Home, Upload } from 'lucide-react'
import Button from '../ui/Button'
import { useAuth } from '../../context/AuthContext'

const Header = () => {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    try {
      await signOut()
      navigate('/login')
    } catch (error) {
      console.error('退出失败:', error)
    }
  }

  const handleNavigation = (path) => {
    navigate(path)
  }

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            className="flex items-center space-x-3 cursor-pointer"
            onClick={() => handleNavigation('/dashboard')}
          >
            <div className="text-2xl">🎵</div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                音频转文档
              </h1>
              <p className="text-xs text-gray-500">
                AI 语音转录工具
              </p>
            </div>
          </div>

          {/* 导航菜单 */}
          <nav className="hidden md:flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleNavigation('/dashboard')}
            >
              <Home className="h-4 w-4 mr-2" />
              首页
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleNavigation('/upload')}
            >
              <Upload className="h-4 w-4 mr-2" />
              上传
            </Button>
          </nav>

          {/* 用户菜单 */}
          <div className="flex items-center space-x-4">
            {user && (
              <div className="hidden md:flex items-center space-x-2 text-sm text-gray-600">
                <User className="h-4 w-4" />
                <span>{user.email}</span>
              </div>
            )}
            
            <Button
              variant="outline"
              size="sm"
              onClick={handleSignOut}
            >
              <LogOut className="h-4 w-4 mr-2" />
              退出
            </Button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header